export interface PhoneParts {
    areaNum: string;
    phoneNum: string;
    [key: string]: string;
}

const isValidLength = (input: string): boolean => {
    // remove non-numeric characters
    const digitOnlyString = input.replace(/\D/g, '');
    return digitOnlyString.length <= 10;
};
const getCaret = (e: React.KeyboardEvent<HTMLInputElement>) => {
    return (e.target as HTMLInputElement).selectionStart as number;
};
const setCaret = (e: React.KeyboardEvent<HTMLInputElement>, pos: number) => {
    const ctrl = e.target as HTMLInputElement;
    ctrl.setSelectionRange(pos, pos);
};
const format = (
    e: React.KeyboardEvent<HTMLInputElement>,
    isDeletePressed: boolean,
    hasBrackets?: boolean
) => {
    let pos = getCaret(e);
    const val = (e.target as HTMLInputElement).value.replace(/\D/g, '');
    let newVal = val;

    if (val.length > 2) {
        if (hasBrackets) {
            // matches: (123) || (123) 4 || (123) 45
            newVal = '(' + val.slice(0, 3) + ') ';
            if (isDeletePressed === false) pos += 3;

            if (val.length === 4 || val.length === 5) {
                // matches: 123-4 || 123-45
                newVal = newVal + val.slice(3);
                if (isDeletePressed === false) pos++;
            } else if (val.length > 5) {
                // matches: (123) 456 || (123) 456-7 || (123) 456-789
                newVal = newVal + val.slice(3, 6) + '-';
                if (isDeletePressed === false) pos++;
            }
            if (val.length > 6) {
                // matches: (123) 456-7 || (123) 456-789 || (123) 456-7890
                newVal = newVal + val.slice(6, 10);
                if (isDeletePressed === false) pos++;
            }
        } else {
            // matches: 123 || 123-4 || 123-45
            newVal = val.slice(0, 3) + '-';

            if (val.length === 4 || val.length === 5) {
                // matches: 123-4 || 123-45
                newVal = newVal + val.slice(3);
            } else if (val.length > 5) {
                // matches: 123-456 || 123-456-7 || 123-456-789
                newVal = newVal + val.slice(3, 6) + '-';
            }
            if (val.length > 6) {
                // matches: 123-456-7 || 123-456-789 || 123-456-7890
                newVal = newVal + val.slice(6, 10);
            }

            // restore cursor selection,
            // prevent it from going to the end
            // UNLESS
            // cursor was at the end
            if (
                newVal.slice(-1) === '-' &&
                isDeletePressed === false &&
                ((newVal.length === 8 && pos === 7) || (newVal.length === 4 && pos === 3))
            ) {
                pos = newVal.length;
            }
        }
    }

    (e.target as HTMLInputElement).value = newVal;
    setCaret(e, pos);
};

const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>, hasBrackets?: boolean) => {
    const key = e.key;
    const isDeletePressed = ['Delete', 'Backspace'].includes(key);
    if (key.includes('Arrow')) {
        // do nothing for direction keys, keep their default actions
        return;
    }

    // only force formatting if a number or delete key was pressed
    if (key.match(/^\d+$/) || isDeletePressed) {
        format(e, isDeletePressed, hasBrackets);
    } else {
        // all other non numerical key presses, remove their value
        e.preventDefault();
        format(e, false, hasBrackets);
    }
};

export const formatPhoneInput = (
    e: React.KeyboardEvent<HTMLInputElement>,
    hasBrackets?: boolean
) => {
    const val = (e.target as HTMLInputElement).value;

    if (!isValidLength(val)) return;

    handleKeyPress(e, hasBrackets);
};

export const splitPhoneNum = (phoneNumber: string, hasBrackets?: boolean, hasDashes?: boolean): PhoneParts | null => {
    let regex;

    switch (true) {
        case hasDashes:
            regex = /^(\d{3})-(\d{3})-(\d{4})$/;
            break;
        case hasBrackets:
            regex = /\((\d{3})\)\s(\d{3})-(\d{4})/;
            break;
        default:
            regex = /^(\d{3})(\d{3})(\d{4})$/;
            break;
    }

    const matches = phoneNumber.match(regex);

    if (matches) {
        const areaNum = matches[1];
        const phoneNum = `${matches[2]}-${matches[3]}`;

        return { areaNum, phoneNum };
    } else {
        return null;
    }
};
